import {createThunkEffect} from '../../utilities/ActionUtility';
import {requestUserInfo as requestUserInfoEffect} from './UserInfoEffect';

export const REQUEST_USERINFO = 'REQUEST_USERINFO';
export const REQUEST_USERINFO_FINISHED = 'REQUEST_USERINFO_FINISHED';

export function requestUserInfo(user) {
  return async (dispatch) => {
    await createThunkEffect(dispatch, REQUEST_USERINFO, requestUserInfoEffect, user);
  };
}
